/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from "react";
import axios from "axios";
import globalStorage from "../global-storage";

function EnquiryForm(props) {
  const contactData = [];
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [successMsg, setSuccessMsg] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!email.trim()) newErrors.email = "Email is required.";
    if (!contactNumber.trim()) {
      newErrors.contactNumber = "Contact number is required.";
    } else if (!/^\d+$/.test(contactNumber)) {
      newErrors.contactNumber = "Contact number must contain digits only.";
    }
    if (!subject.trim()) {
      newErrors.subject = `${props.subjectLabel || "Address"} is required.`;
    }
    if (!message.trim()) newErrors.message = "Message is required.";
    return newErrors;
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    contactData.push({
      contactName: name,
      emailId: email,
      subject: subject,
      message: message,
      contactNumber: contactNumber,
      contactType: props.type,
      status: false
    });

    axios.post(`${globalStorage.apiUrl}MtContactUs`, contactData)
      .then((response) => {
        console.log(response);
        setSuccessMsg(true);
        props.successStatus(true);
        setName(""); setEmail(""); setSubject(""); setMessage(""); setContactNumber("");
      }, (error) => {
        console.log(error);
      });
  };

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>{props.title}</h2>
          <p>{props.subTitle}</p>
        </div>
        <div className="row mt-5">
          <div className="col-lg-12 mt-5 mt-lg-0">
            <form onSubmit={handleSubmit}>
              <div className="php-email-form">
                <div className="form-row">
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={e => setName(e.target.value)}
                      placeholder="Your Name"
                    />
                    {errors.name && <small className="text-danger">{errors.name}</small>}
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      placeholder="Your Email"
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={contactNumber}
                      onChange={e => setContactNumber(e.target.value)}
                      placeholder="Your Contact Number"
                    />
                    {errors.contactNumber && <small className="text-danger">{errors.contactNumber}</small>}
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      className="form-control"
                      value={subject}
                      onChange={e => setSubject(e.target.value)}
                      placeholder={props.subjectPlaceholder || "Address"} 
                    />
                    {errors.subject && <small className="text-danger">{errors.subject}</small>}
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    className="form-control"
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    rows="5"
                    placeholder="Message"
                  />
                  {errors.message && <small className="text-danger">{errors.message}</small>}
                </div>

                <div className="mb-3">
                  {successMsg &&
                    <div className="alert alert-success" role="alert">
                      Your Request Sent Successfully.
                    </div>
                  }
                </div>
                <div className="text-center">
                  <button type="submit">Send Request</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EnquiryForm;
